import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';
import { getLeafCategories, getProducts } from '../api';
import PageWrapper from '../components/PageWrapper';
import ProductCard from '../components/ProductCard';
import Loader from '../components/Loader';

export default function Products() {
  const [params, setParams] = useSearchParams();
  const [leaves, setLeaves] = useState([]);
  const [products, setProducts] = useState(null);
  const [cat, setCat] = useState('all'); // 'all' or a category _id
  const [q, setQ] = useState('');

  // Load category filter chips (leaf categories only).
  useEffect(() => {
    getLeafCategories(true).then(setLeaves).catch(() => setLeaves([]));
  }, []);

  // Pre-select the category from the URL (?category=<slug|id>) once chips load.
  useEffect(() => {
    const key = params.get('category');
    if (!key || !leaves.length) return;
    const match = leaves.find((c) => c.slug === key || c._id === key);
    if (match) setCat(match._id);
  }, [params, leaves]);

  // Fetch products whenever the filter or search changes.
  useEffect(() => {
    setProducts(null);
    const query = {};
    if (cat !== 'all') query.categoryId = cat;
    if (q) query.q = q;
    const t = setTimeout(() => {
      getProducts(query).then(setProducts).catch(() => setProducts([]));
    }, 250);
    return () => clearTimeout(t);
  }, [cat, q]);

  const selectCat = (value) => {
    setCat(value);
    if (value === 'all') setParams({});
    else {
      const c = leaves.find((l) => l._id === value);
      setParams(c ? { category: c.slug } : {});
    }
  };

  return (
    <PageWrapper>
      <section className="section">
        <div className="container">
          <span className="eyebrow">Our collection</span>
          <h1 className="section-title">Products</h1>
          <p className="section-sub">Browse our full range. Tap any product to view details, colours and share it.</p>

          <div className="toolbar">
            <div className="field" style={{ margin: 0, flex: 1, minWidth: 220, position: 'relative' }}>
              <FiSearch style={{ position: 'absolute', left: 14, top: 14, color: 'var(--muted)' }} />
              <input
                className="input"
                style={{ paddingLeft: 40 }}
                placeholder="Search products…"
                value={q}
                onChange={(e) => setQ(e.target.value)}
              />
            </div>
          </div>

          {leaves.length > 0 && (
            <div className="toolbar">
              <button className={`chip ${cat === 'all' ? 'active' : ''}`} onClick={() => selectCat('all')}>All</button>
              {leaves.map((c) => (
                <button key={c._id} className={`chip ${cat === c._id ? 'active' : ''}`} onClick={() => selectCat(c._id)}>{c.name}</button>
              ))}
            </div>
          )}

          {products === null ? (
            <Loader />
          ) : products.length ? (
            <div className="grid grid-4">
              {products.map((p, i) => <ProductCard key={p._id} product={p} index={i} />)}
            </div>
          ) : (
            <div className="empty">
              <div className="empty__icon">🔍</div>
              <h3>No products found</h3>
              <p>Try a different search or category.</p>
            </div>
          )}
        </div>
      </section>
    </PageWrapper>
  );
}
